/* eslint-disable vue/multi-word-component-names */
import Vue from "vue";

Vue.component("Loader", () => import("./Loaders/FullscreenLoader.vue"));
Vue.component("Tooltip", () => import("./Tooltip/Tooltip.vue"));
Vue.component("TooltipRealtime", () => import("./Measures/TooltipRealtime.vue"));
Vue.component("TooltipConstant", () => import("./Measures/TooltipConstant.vue"));
Vue.component("TooltipAlarm", () => import("./Measures/TooltipAlarm.vue"));
Vue.component("SvgIcon", () => import("./Icons/SvgIcon.vue"));
